import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  PrimaryBlueButton,
  SecondaryBlueButton
} from "@velaro/velaro-component-lib";
import React, { useState } from "react";
import { ContactFieldDef, FieldDefinition, FieldOption } from ".";
import FieldForm from "./FieldForm";

interface Props {
  field: ContactFieldDef;
  onCancel(): void;
  onSave(definition: FieldDefinition): void;
}

export default function EditFieldModal({ field, onCancel, onSave }: Props) {
  const [definition, setDefinition] = useState<FieldDefinition>(() => {
    let options: FieldOption[] = [];
    if (field.options) {
      try {
        const parsed = JSON.parse(field.options);
        if (Array.isArray(parsed)) {
          options = parsed.map((v: string, i: number) => ({
            label: v,
            value: v,
            id: String(i)
          }));
        }
      } catch {
        // Invalid JSON, keep empty options
      }
    }
    return {
      label: field.label,
      type: field.type as FieldDefinition["type"],
      options,
      scope: (field.scope as FieldDefinition["scope"]) ?? "conversation",
      persistent: field.persistent ?? false,
      description: field.description ?? ""
    };
  });

  const [saving, setSaving] = useState(false);

  function handleSave() {
    setSaving(true);
    onSave(definition);
  }

  return (
    <Modal show={true}>
      <ModalHeader title="Edit Field" onClose={onCancel} />
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSave();
        }}
      >
        <ModalBody>
          <div className="p-4">
            <FieldForm
              field={definition}
              onChange={(updates) =>
                setDefinition((prev) => ({ ...prev, ...updates }))
              }
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="flex p-4">
            <div className="ml-auto flex flex-row">
              <div className="mr-2">
                <SecondaryBlueButton label="Cancel" onClick={onCancel} />
              </div>
              <PrimaryBlueButton
                label={saving ? "Saving..." : "Save Changes"}
                disabled={saving || !definition.label.trim()}
                onClick={handleSave}
              />
            </div>
          </div>
        </ModalFooter>
      </form>
    </Modal>
  );
}
